import { render, staticRenderFns } from "./SinoForeignCooperation_mobile.vue?vue&type=template&id=9e2d172a&scoped=true"
import script from "./SinoForeignCooperation_mobile.vue?vue&type=script&lang=js"
export * from "./SinoForeignCooperation_mobile.vue?vue&type=script&lang=js"
import style0 from "./SinoForeignCooperation_mobile.vue?vue&type=style&index=0&id=9e2d172a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2d172a",
  null
  
)

export default component.exports